/**
 * The app shell — §4.3 shell 1.
 *
 * Above the router: the <audio> element, the theme attribute on <html>, and the
 * library hydration. NEVER UNMOUNTED.
 */
import { useEffect } from 'react'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { AudioEngine } from '../audio/AudioEngine'
import { useLibrary } from '../stores/library'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootShell,
})

function RootShell() {
  const hydrate = useLibrary((s) => s.hydrate)

  useEffect(() => {
    void hydrate()
  }, [hydrate])

  return (
    // `app-shell` carries the safe-area insets (app.css). It belongs HERE rather than on
    // each route's own wrapper: the inset is a property of the device, not of the route,
    // and the one element above every route is the one place it cannot be forgotten.
    <div className="app-shell flex h-full min-h-0 flex-col bg-surface text-ink">
      {/* A1: mounted here, above every route, and never remounted by navigation. */}
      <AudioEngine />
      <Outlet />
    </div>
  )
}
